import ProductList from './ProductList.js';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import mapProps from 'recompose/mapProps';
import when from 'recompose/branch';
import { withModel } from '../../data-providers/model';
import { getAvailableProductIds, findLowestProductPrice } from 'src/common/utils/product';
import { withFiltering } from './helpers';

const enhance = compose(
  withModel,
  withProps(props => ({
    products: props.model.eagleModel.products,
    availableProductIds: getAvailableProductIds(props.model.eagleModel.products)
  })),
  mapProps(props => ({
    ...props.primary,
    items: props.items
      .filter(item => props.availableProductIds.includes(item.product.main.productId))
      .map(item => ({
        ...findLowestProductPrice(props.products, item.product.main.productId),
        ...item.product.productInformation,
        productId: item.product.main.productId,
        badge: item.badge,
      }))
      .filter(item => item.price),
  })),
  when(props => props.addFiltering, withFiltering)
);

export default enhance(ProductList);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductList/index.js